import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import { getPage } from '../services/pageService';

const Thanks = () => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadThanks = async () => {
      const page = await getPage('thanks');
      setContent(page?.contentHtml || '');
      setIsLoading(false);
    };
    loadThanks();
  }, []);

  return (
    <>
      <div className="container-fluid page-top">
        <div className="container">
          <div className="row">
            <h2>Agradecimientos</h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="py-4">
              {isLoading ? (
                <LoadingSpinner label="Cargando agradecimientos..." />
              ) : (
                <div dangerouslySetInnerHTML={{ __html: content }} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Thanks;